var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLocationPin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 14,
    viewBox: "0 0 11 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.5 0C8.53267 0 11 2.58897 11 5.77155C11 9.68382 6.696 13.5385 5.5 13.5385C4.304 13.5385 0 9.68382 0 5.77155C0 2.58897 2.46733 0 5.5 0ZM5.5 1.04142C3.01867 1.04142 1 3.16383 1 5.77155C1 9.08951 4.74933 12.3221 5.5 12.4943C6.25067 12.3214 10 9.08882 10 5.77155C10 3.16383 7.98133 1.04142 5.5 1.04142ZM5.50067 3.4714C6.69533 3.4714 7.66733 4.48366 7.66733 5.72851C7.66733 6.97266 6.69533 7.98422 5.50067 7.98422C4.306 7.98422 3.334 6.97266 3.334 5.72851C3.334 4.48366 4.306 3.4714 5.50067 3.4714ZM5.50067 4.51282C4.85733 4.51282 4.334 5.05783 4.334 5.72851C4.334 6.39849 4.85733 6.9428 5.50067 6.9428C6.144 6.9428 6.66733 6.39849 6.66733 5.72851C6.66733 5.05783 6.144 4.51282 5.50067 4.51282Z",
    fill: "#767676"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationPin);
export default __webpack_public_path__ + "static/media/locationPin.9869603258c84fdb35be07a1bf80d854.svg";
export { ForwardRef as ReactComponent };